import { Insight } from '@model-main/dashboards/model/insight';
import { Observable } from 'rxjs';
import { ObjectViewer } from './object-viewer.model';

export abstract class InsightViewer extends ObjectViewer {
    insight$: Observable<Partial<Insight>>;
}
